import { useState } from 'react';

import { useDebouncedCallback } from 'use-debounce';

import type { ChangeEvent } from 'react';

/**
 * Shared behaviour for the "type to search" inputs used across the app:
 * the displayed value updates immediately on every keystroke, while
 * `onSearch` only fires once typing has paused for `delay` ms.
 */
export const useDebouncedSearch = (
  onSearch: (query: string) => void,
  delay = 600
): { value: string; onChange: (event: ChangeEvent<HTMLInputElement>) => void } => {
  const [value, setValue] = useState('');

  const debouncedSearch = useDebouncedCallback((query: string) => {
    onSearch(query);
  }, delay);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    debouncedSearch(event.target.value);
  };

  return { value, onChange };
};
